import { render, staticRenderFns } from "./GatheringView.vue?vue&type=template&id=1520efae"
import script from "./GatheringView.vue?vue&type=script&lang=js"
export * from "./GatheringView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports